import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import Header from '@/components/Header.jsx';
import Footer from '@/components/Footer.jsx';
import AssessmentForm from '@/components/AssessmentForm.jsx';
import { Clock, ShieldCheck } from 'lucide-react';

function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Solicitar evaluación | Faronexo</title>
        <meta name="description" content="Solicitá un diagnóstico, un escaneo de seguridad, una consulta o un servicio de ciberseguridad con Faronexo." />
      </Helmet>
      <Header />
      <main className="bg-background">
        <section className="fx-hero" style={{ paddingBottom: '8px' }}>
          <div className="fx-container">
            <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="fx-hero-copy" style={{ paddingBlock: '30px' }}>
              <span className="fx-eyebrow"><span className="fx-dot" /> Primer paso</span>
              <h1>Solicitá una <span>evaluación</span></h1>
              <p className="fx-intro" style={{ maxWidth: '680px' }}>
                Elegí qué necesitás y te pediremos solo la información relevante. Todas las solicitudes quedan registradas para revisión del equipo.
              </p>
              <div className="fx-hero-notes">
                <span><Clock className="w-4 h-4" /> Respuesta en 24h hábiles</span>
                <span><ShieldCheck className="w-4 h-4" /> Ningún escaneo se inicia sin aprobación</span>
              </div>
            </motion.div>
          </div>
        </section>
        <section className="fx-section" style={{ paddingTop: '40px' }}>
          <div className="fx-container">
            <div className="max-w-3xl mx-auto"><AssessmentForm /></div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
export default ContactPage;
